import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { active: Boolean }

  connect() {
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (!this.activeValue || this.timer) return

    this.timer = setInterval(() => window.location.reload(), 8000)
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
}
